import { BrowserRouter, Route, Routes, useLocation, useNavigate, useNavigation } from "react-router-dom"
import "./Assets/Styles/tabler.css";
import "./Assets/Styles/tabler-marketing.css";
import "./Assets/Styles/style.css";
import IndexPage from './Pages/Index';
import PlansPage from './Pages/Plans';
import Header from './Components/Header';
import Footer from "./Components/Footer";
import TermsOfUsePage from "./Pages/TermsOfUse";
import PrivacyPolicyPage from "./Pages/PrivacyPolicy";
import { useEffect } from "react";

export default function App() {

  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0) }, [location]);

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/planos" element={<PlansPage />} />
        <Route path="/termos-de-uso" element={<TermsOfUsePage />} />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
      </Routes>
      <Footer />
    </>
  );
}